import './signature-module-screen.scss'

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Component from 'vue-class-component';

import { ReactiveVue } from '@skinsoft/reactive-vue';

import { CLOSE_SIGNATURE_MODULE_TOPIC, SAVE_CURRENT_REPORT_TOPIC } from '../../../../busTopics';
import { SignerInputCard } from '../signer-input-card';

@Component({
    components: {
        sSignerInputCard: SignerInputCard
    },
    props: ['signers'],
    template: require('./signature-module-screen.html')
})
export class SignatureModuleScreen extends ReactiveVue {

    public signers: any[];

    private backIcon = faArrowLeft;

    private closeSignatureModule() {
        this.emitOnBus(CLOSE_SIGNATURE_MODULE_TOPIC)
    }

}